import React from 'react';


export default function Footer() {
  return (
    <div className=' flex justify-center py-1 text-sm bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white font-light shadow-lg fixed bottom-0 w-screen'><p className=' text-center'>Created by Miguel Cuello - Thanks to Prográmate by Educamás
  <br/>
   2022</p></div>
 
  )
}
